import cyberpunk from "../assets/cyber.jpg";
import gta from "../assets/gta.jpg";
import spiderman from "../assets/miles.jpg";
export const carouselData = [
    {
        image: cyberpunk,
        productId: "608c457a5b54f72e84a93407"
    },
    {
        image: gta,
        productId: "608c457a5b54f72e84a93405"
    },
    {
        image: spiderman,
        productId: "608c457a5b54f72e84a93406"
    }
];
